// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TUHph","burger":"Header_burger__Mm9Mv","logo":"Header_logo__oDFTU","nav":"Header_nav__g7vmd","navItem":"Header_navItem__hY1v9"};